var render, staticRenderFns
import script from "./ChartDoughnutPlugin.vue?vue&type=script&lang=js"
export * from "./ChartDoughnutPlugin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29755ce3",
  null
  
)

export default component.exports